
import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import { useHistory, useLocation } from 'react-router-dom'
import {openOverlay} from '../../../store/actions/riskActions'
import { useTranslation } from 'react-i18next';

const TopRisks = ({ height, risks, openOverlayFN }) => {
  const { t } = useTranslation();
  const risksDemo = [
    { id: 'R-101', name: 'Data Breach', type: 'IT', severity: 'Extreme' },
    { id: 'R-102', name: 'Regulatory Violation', type: 'Compliance', severity: 'High' },
    { id: 'R-103', name: 'System Downtime', type: 'Operational', severity: 'High' },
    { id: 'R-104', name: 'Third-Party Failure', type: 'Operational', severity: 'Moderate' },
    { id: 'R-105', name: 'Improper Access Control', type: 'IT', severity: 'Low' },
  ];

  const history = useHistory()
  const { pathname } = useLocation()

  const [risksList, setrisksList] = useState([]); 
   useEffect(() => {
      if (risks) {
          setrisksList(risks)
      }
  }, [risks]);

  const getNumber = (damage) => {
    switch (damage) {
      case 'Insignificant':
        return 1;
      case 'Minor':
        return 2;
      case 'Moderate':
        return 3;
      case 'Major':
        return 4;
      case 'Catastrophe':
        return 5;
      default:
        return 0;
    }
  };

  const getMultiply = (probability) => {
    switch (probability) {
      case 'Rare':
        return 1;
      case 'Unlikely':
        return 2;
      case 'Possible':
        return 3;
      case 'Likely':
        return 4;
      case 'Almost certain':
        return 5;
      default:
        return 0;
    }
  };



  const getSeverity = (damage, probability) => {
    const rank = damage * probability
    //////console.log(damage, " | ", probability, rank, getSeverityColor("Moderate"))
    
    if (rank < 3) {
      return "Low"
    } else if (rank < 8) {
     return "Moderate"
    } else if (rank < 15) {
      return "High"
    } else {
      return "Extreme"
}
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Extreme':
        return 'text-red-700 font-semibold';
      case 'High':
        return 'text-orange-600 font-semibold';
      case 'Moderate':
        return 'text-yellow-600 font-medium';
      case 'Low':
        return 'text-green-600 font-medium';
      default:
        return '';
    }
  };

  const goToRisk = (id) => {
    openOverlayFN(id)
    history.push(`/risk_overview/${id}`, { fromPage: "dashboards" });
  };

  return (
    <div className="w-full bg-white rounded-lg" style={{ height }}>
      <div className="h-full overflow-y-auto px-4 py-2">
        {risksList.map((risk, index) => (
          <div
            key={index}
            className="flex justify-between items-center py-2 text-xs border-b border-gray-100 hover:bg-gray-200 p-2 rounded-md"
            onClick={() => goToRisk(risk.risk_id)}
          >
            <span className="w-[10%]">{index + 1}</span>
            <span className="w-[40%] truncate text-gray-600 underline-offset-2 cursor-pointer" >{risk.title}</span>
            <span className="w-[40%]">{risk.department_name}</span>
            <span className={`w-[10%] text-right ${getSeverityColor(getSeverity((getNumber(risk.financial_impact) +getNumber(risk.operational_impact) + getNumber(risk.reputational_impact))/3 ,getMultiply(risk.probability)))}`}>
              {t(`generalDashboard.severity.${getSeverity((getNumber(risk.financial_impact) +getNumber(risk.operational_impact) + getNumber(risk.reputational_impact))/3 ,getMultiply(risk.probability))}`)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
    ////console.log(state.dashboard.general_dashboard_data.top5Risks)
    return {

        risks: state.dashboard.general_dashboard_data.top5Risks,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
         openOverlayFN: (id) => dispatch(openOverlay(id)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(TopRisks);